import React, { useState, useEffect } from 'react';
import { IoIosArrowUp } from "react-icons/io";
const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Function to check scroll position
    const handleScroll = () => {
      if (window.scrollY > 400) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    // Event listener for scroll
    window.addEventListener('scroll', handleScroll);

    // Cleanup function
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <div className={`scroll-to-top ${isVisible ? 'show' : ''}`}>
      {isVisible && (
        <button onClick={scrollToTop} className="scroll-to-top-btn">
       <IoIosArrowUp  size={25} />

        </button>
      )}
    </div>
  );
};

export default ScrollToTopButton;
